import { useActivityPageContext } from "PFApp/activities/show/activity_page_context";
import AppContext from "PFApp/app_context";
import ProfileCardConnected from "PFApp/components/profile_card_connected";
import { profileResponseShapePropType } from "PFCore/base/prop_types/profile_response_prop_types";
import { isProfileActive } from "PFCore/helpers/profile";
import { useTemplate } from "PFCore/helpers/templates";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import ChatWithIcon from "../parts/chat_with_icon";
import { useActivityChat } from "../parts/hooks/use_activity_chat";
import InviteButton from "../parts/invite_button";
import InterestedPill from "./interested_pill";
import css from "./matches_item.module.scss";
import MatchesItemRoleButtons from "./matches_item_role_buttons";

const MatchesItem = ({ match, withChat }) => {
  const { task, isActivityUnbiased } = useActivityPageContext();
  const {
    store: { currentProfile }
  } = useContext(AppContext);
  const { startChat } = useActivityChat();
  const template = useTemplate(task.template_id);
  const templateKey = template.key;
  const isRole = templateKey === "role";
  const isAuditRole = templateKey === "audit_role";
  const isDraft = task.state === "draft";
  const isPrivate = task.private;
  const showInviteButton = !isDraft && task.coowned && !isRole && !isAuditRole && isPrivate;

  const { profile } = match;
  const isActive = isProfileActive(profile);
  const isMe = match.profile.id === currentProfile.id;

  return (
    <ProfileCardConnected
      key={profile.id}
      profileResponse={match}
      embeded
      Icon={!isMe && withChat && !isDraft && isActive && ChatWithIcon}
      isBlindModeOn={isActivityUnbiased}
      currentProfile={currentProfile}
      handleIconClick={() => startChat(profile)}
      actions={
        <div className={css.actions}>
          {isRole && profile.interested && <InterestedPill />}
          {(isRole || isAuditRole) && <MatchesItemRoleButtons profile={profile} task={task} />}
          {showInviteButton && <InviteButton profile={profile} task={task} />}
        </div>
      }
    />
  );
};

MatchesItem.propTypes = {
  match: profileResponseShapePropType.isRequired,
  otherConversations: PropTypes.array,
  participantsOfConversations: PropTypes.object,
  withChat: PropTypes.bool.isRequired
};

export default MatchesItem;
